import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {PageCommandModel} from '../../page-commands/page-command.model';
import {buttonsLabelsDefaults, ButtonsLabelType} from '../modern-form-builder/modern-form-builder.component';
import {ICONS_MAP} from '../../../../shared/constnts/icons-map';

@Component({
  selector: 'app-modern-form-panel',
  templateUrl: './modern-form-panel.component.html',
  styleUrls: ['./modern-form-panel.component.scss']
})
export class ModernFormPanelComponent implements OnInit {
  @Input() pageCommands: PageCommandModel[] = [];
  @Input() panelTitle = '';
  @Input() updatePrivilege? = true;
  @Input() isFullHeight = true;
  @Input() buttons: ButtonsLabelType = {};
  @Input() hideFooter = false;
  // tslint:disable-next-line:max-line-length
  @Input() buttonsLabels: ButtonsLabelType = buttonsLabelsDefaults;
  @Input() buttonsTitles: ButtonsLabelType = {};
  buttonLabelsDefaults = buttonsLabelsDefaults;
  // tslint:disable-next-line:max-line-length
  @Input() isModal = false;
  @Input() buttonsColor: {
    save?: string;
    create?: string;
    copy?: string;
    delete?: string;
    deleteFile?: string;
    savetitle?: string;
    operatingmode?: string;
    timeschedule?: string;
    upload?: string;
    view?: string;
    extcommand?: string;
  } =
    // tslint:disable-next-line:max-line-length
    {
      save: 'primary',
      create: 'primary',
      copy: 'primary',
      delete: 'primary',
      deleteFile: 'primary',
      operatingmode: 'primary',
      timeschedule: 'primary',
      upload: 'primary',
      view: 'primary',
      extcommand: 'primary'
    };
  // tslint:disable-next-line:max-line-length
  @Input() disable: {
    reload?: string | boolean;
    save?: string | boolean;
    create?: string | boolean;
    copy?: string | boolean;
    delete?: string | boolean;
    deleteFile?: string | boolean;
    operatingmode?: string | boolean;
    timeschedule?: string | boolean;
    upload?: string | boolean;
    view?: string | boolean;
    extcommand?: string | boolean;
    cancel?: string | boolean;
    addinterval?: string | boolean;
    createnew?: string | boolean;
  } = {};
  @Input() accept?: string = null;
  @Input() fullSize = false;
  @Input() fullHeight = false;

  @Output() save = new EventEmitter<any>();
  @Output() create = new EventEmitter<any>();
  @Output() createnew = new EventEmitter<any>();
  @Output() duplicate = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<any>();
  @Output() view = new EventEmitter<any>();
  @Output() reload = new EventEmitter<any>();
  @Output() deleteFile = new EventEmitter<any>();
  @Output() operatingmode = new EventEmitter<any>();
  @Output() timeschedule = new EventEmitter<any>();
  @Output() upload = new EventEmitter<any>();
  @Output() extcommand = new EventEmitter<any>();
  @Output() addinterval = new EventEmitter<any>();
  @ViewChild('fileInput', {static: false}) el: ElementRef;
  file: File = null;

  protected readonly buttonsLabelsDefaults = buttonsLabelsDefaults;
  protected readonly ICONS_MAP = ICONS_MAP;

  constructor() {
  }

  ngOnInit() {
    return;
  }

  public onSave() {
    this.save.next({});
  }

  public onCreate() {
    this.create.next({});
  }
  public onCreateNew() {
    this.createnew.next({});
  }
  public onAddInterval() {
    this.addinterval.next({});
  }

  public onDuplicate() {
    this.duplicate.next({});
  }

  public onDelete() {
    this.delete.next({});
  }
  public onCancel() {
    this.cancel.next({});
  }

  public onView() {
    this.view.next({});
  }

  public onReload() {
    this.reload.next({});
  }

  public onOperatingMode() {
    this.operatingmode.next({});
  }

  public onTimeSchedule() {
    this.timeschedule.next({});
  }

  public onExtcommand() {
    this.extcommand.next({});
  }

  onClickChoose() {
    this.el.nativeElement.click();
  }

  onChangeFile(e, fileInput) {
    e.preventDefault();
    if (e.target.files[0]) {
      this.file = e.target.files[0];
      this.upload.emit(e.target);
    }
    this.file = null;
    this.el.nativeElement.value = '';
  }
}
